"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogsPack = exports.FileStream = void 0;
const log_1 = require("./log");
const utils_1 = require("./utils");
const fileNameRegex = /^([\d-]+)\((\d+)\)\.log$/;
class FileStream {
    constructor(fileHandle, debug) {
        this.fileHandle = fileHandle;
        this.queue = [];
        this.isOpen = false;
        this.bufferCount = 0;
        this.flush = this.flush.bind(this);
    }
    async flush() {
        var _a;
        (0, log_1.debug)(">>>flush", this.bufferCount);
        if (this.bufferCount === 0)
            return;
        this.isOpen = false;
        try {
            await this.currentStream.close();
        }
        catch (e) {
            (0, log_1.debug)(">> Failed to close stream");
        }
        const file = await this.fileHandle.getFile();
        this.currentStream = await this.fileHandle.createWritable({
            keepExistingData: true,
        });
        (_a = this.onFileChange) === null || _a === void 0 ? void 0 : _a.call(this, file);
        await this.currentStream.seek(file.size);
        (0, log_1.debug)(">>>flush", this.queue);
        this.queue.forEach((data) => {
            this.currentStream.write(data);
        });
        this.queue = [];
        this.bufferCount = 0;
        this.isOpen = true;
        (0, log_1.debug)(">>>flush end");
    }
    async create() {
        this.currentStream = await this.fileHandle.createWritable({
            keepExistingData: true,
        });
        const file = await this.fileHandle.getFile();
        this.currentStream.seek(file.size);
        this.isOpen = true;
        let isFlushing = false;
        this.flushIntervalId = window.setInterval(() => {
            if (!isFlushing) {
                isFlushing = true;
                this.flush()
                    .then(() => {
                    isFlushing = false;
                })
                    .catch(() => {
                    isFlushing = false;
                });
            }
        }, 10000);
        window.addEventListener("beforeunload", () => {
            !isFlushing && this.flush();
        });
    }
    async writeLine(data) {
        if (!this.isOpen || !this.currentStream) {
            this.queue.push(data);
            return;
        }
        (0, log_1.debug)("wirteline", data);
        this.bufferCount++;
        return this.currentStream.write(data);
    }
    async close() {
        var _a;
        clearInterval(this.flushIntervalId);
        window.removeEventListener("beforeunload", this.flush);
        try {
            await ((_a = this.currentStream) === null || _a === void 0 ? void 0 : _a.close());
        }
        catch (error) {
            if (error instanceof TypeError && error.message.includes("CLOSED")) {
                (0, log_1.debug)(">> stream already closed");
            }
            else {
                throw error;
            }
        }
    }
}
exports.FileStream = FileStream;
class LogsPack {
    constructor(dir, name, maxSize) {
        this.dir = dir;
        this.name = name;
        this.maxSize = maxSize;
        this.creatingNewFile = false;
        this.queue = [];
    }
    async getPacks() {
        const packFilenames = [];
        for await (const fileName of this.dir.keys()) {
            if (fileName.startsWith(this.name) && fileNameRegex.test(fileName)) {
                packFilenames.push(fileName);
            }
        }
        return packFilenames;
    }
    async create() {
        var _a;
        const packFiles = await this.getPacks();
        packFiles.sort((a, b) => {
            const [, , partA] = a.match(fileNameRegex);
            const [, , partB] = b.match(fileNameRegex);
            return Number(partA) - Number(partB);
        });
        (0, log_1.debug)(">>> pack", packFiles);
        const lastFileName = (_a = packFiles[packFiles.length - 1]) !== null && _a !== void 0 ? _a : (0, utils_1.getFilename)(this.name, 0);
        const fileHandle = await this.dir.getFileHandle(lastFileName, {
            create: true,
        });
        const fileStream = new FileStream(fileHandle);
        fileStream.onFileChange = this.onFileChanged.bind(this);
        await fileStream.create();
        this.currentFileStream = fileStream;
        (0, log_1.debug)(">>> pack", this.currentFileStream.fileHandle.name);
    }
    async onFileChanged(file) {
        var _a;
        (0, log_1.debug)(">>> file change", file.size);
        if (file.size < this.maxSize)
            return;
        this.creatingNewFile = true;
        await ((_a = this.currentFileStream) === null || _a === void 0 ? void 0 : _a.close());
        const [, base, part] = file.name.match(fileNameRegex);
        const fileHandle = await this.dir.getFileHandle((0, utils_1.getFilename)(base, Number(part) + 1), {
            create: true,
        });
        const fileStream = new FileStream(fileHandle);
        await fileStream.create();
        fileStream.onFileChange = this.onFileChanged.bind(this);
        this.currentFileStream = fileStream;
        (0, log_1.debug)(">>> pack file change", this.currentFileStream.fileHandle.name);
        this.creatingNewFile = false;
    }
    async writeLine(data) {
        var _a;
        if (this.creatingNewFile) {
            this.queue.push(data);
            return;
        }
        (_a = this.currentFileStream) === null || _a === void 0 ? void 0 : _a.writeLine(data);
    }
    async clear() {
        var _a;
        await ((_a = this.currentFileStream) === null || _a === void 0 ? void 0 : _a.close());
        const files = await this.getPacks();
        files.forEach((file) => {
            this.dir.removeEntry(file);
        });
    }
}
exports.LogsPack = LogsPack;
